<template>
    <div class="rr-windows-wrapper">
        <transition name="width">
            <div class="rrww-btn l" @click="windowItem--" v-if="windowItem != 0">
                <i class="pi pi-angle-left"></i>
            </div>
        </transition>
        <div class="rrtsvc-windows">
            <transition-group :name="transition">
                <div class="rrtsvcw-window" v-if="windowItem == 0">
                    <UiCalendar :customerInfo="customerInfo"/>
                </div>
                <div class="rrtsvcw-window" v-if="windowItem == 1">
                    <div class="rrlbf-services">
                        <div class="rrlbfs-service" v-for="(service) in services" :key="service.id">
                            <RadioButton v-model="selectedService" :inputId="service.id" :name="service.id" :value="service.id" />
                            <label :for="service.id" class="ml-2">{{ service.name }} <small>
                                {{ new Intl.NumberFormat('cs-CZ', {
                                    style: 'currency',
                                    currency: service.currency,
                                }).format(service.price) }}
                            </small></label>
                        </div>
                    </div>
                </div>
                <div class="rrtsvcw-window" v-if="windowItem == 2">
                    <UiForm></UiForm>
                </div>
            </transition-group>
        </div>
        <transition name="width">
            <div class="rrww-btn r" @click="windowItem++" v-if="windowItem < 2">
                <i class="pi pi-angle-right"></i>
            </div>
        </transition>
    </div>
</template>
<script setup>
import RadioButton from 'primevue/radiobutton';
import UiCalendar from '../ui-components/UiCalendar.vue';
import UiForm from '../ui-components/UiForm.vue';
import { ref, defineProps, watch } from 'vue';
defineProps({
    customerInfo: Object
});
const windowItem = ref(0);
const transition = ref('list');
watch(windowItem, (now, before) => {
    if(now < before) transition.value = 'list';
    else transition.value = 'rlist';
})
const selectedService = ref('');
const services = ref([
    {
        id: 'strihani',
        name: 'Mužské stříhání',
        price: 600.0,
        currency: 'CZK',
        per: 'unit'
    }
]);

</script>
<style scoped lang="scss">
.width-enter-active,
.width-leave-active {
    transition: all .3s ease;
}
.width-enter-from
.width-leave-to {
    opacity: 0;
}

.list-enter-active,
.list-leave-active,
.rlist-enter-active,
.rlist-leave-active  {
    transition: all 0.5s ease;
}
.list-enter-from {
    opacity: 0;
    transform: translateX(30px);
}
.rlist-enter-from {
    opacity: 0;
    transform: translateX(-30px);
}
.list-leave-from {
    transform: translateX(0px);
}
.list-leave-to {
    opacity: 0;
    transform: translateX(-30px);
}
.rlist-leave-from {
    transform: translateX(0px);
}
.rlist-leave-to {
    opacity: 0;
    transform: translateX(30px);
}
.rr-windows-wrapper {
    display: flex;
    min-height: 355px;
    .rrww-btn {
        width: 50px;
        min-width: 50px;
        background-color: var(--primary-color);
        margin: -36px;
        display:flex;
        align-items: center;
        justify-content: center;
        color: var(--primary-color-text)!important;
        transition: opacity .3s ease;
        cursor: pointer;
        &:hover {
            opacity: .8;
        }
        &.l {
            margin-right: 36px;
            border-top-left-radius: 10px;
            border-bottom-left-radius: 10px;
        }
        &.r {
            margin-left: 36px;
            border-top-right-radius: 10px;
            border-bottom-right-radius: 10px;
        }
    }
    .rrtsvc-windows {
        width: 100%;
        .rrtsvcw-window {

            position: absolute;
        }
    }
}
.rrlb-timeslot {
    display: flex;
    gap: 36px;
    .rrlbf-services
    {
        display:flex;
        gap: 12px;
        .rrlbfs-service {
            display: flex;
            gap: 8px;
            align-items: center;
        }
    }
}

</style>
